<template>
  <cms-shell :data="data" title="Autos" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
    Desktop
    <textarea type="text" class="form-control" v-model="data.value"  placeholder="Text"/>
    <br>
    Mobile
    <textarea type="text" class="form-control" v-model="data.valueMobile"  placeholder="Text"/>
  </cms-shell>
</template>

<script>
    import CmsShell from "./CmsShell";

    export default {
      components: {CmsShell},
      name: "cms-cars",
      props:['data']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsCars.vue